
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_KEY as string;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'supabase-auth-token',
    storage: localStorage
  }
});

// Add debugging to track auth status changes
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Supabase Client - Auth State Change', {
    event,
    sessionPresent: !!session,
    userId: session?.user?.id || 'No user'
  });
});
